import { GameStore } from '@/features/games/shared/store/game-store';

export const selectGamePrice = (gameId: string) => (s: GameStore) => s.prices[gameId]; // GamePriceDataResponse | undefined
